export default __webpack_public_path__ + "static/media/poc_one.b80e0751.usdz";